import React from 'react';


export const WalletRegistration = () => {
    return (
        <div>Wallet Registration</div>
    )
}